import { render, staticRenderFns } from "./tallaParaLaEdadNinos2a5A.vue?vue&type=template&id=01f02f84&scoped=true"
import script from "./tallaParaLaEdadNinos2a5A.vue?vue&type=script&lang=js"
export * from "./tallaParaLaEdadNinos2a5A.vue?vue&type=script&lang=js"
import style0 from "./tallaParaLaEdadNinos2a5A.vue?vue&type=style&index=0&id=01f02f84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f02f84",
  null
  
)

export default component.exports